import { getAccountInfo as getAccountInfoApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetAccountInfoServiceResponse } from './getAccountInfo.dto';
import { GetAccountInfoServiceResponseSchema } from './getAccountInfo.dto';

export const getAccountInfoService = withServiceErrorCapture(
  lazyPipe(
    async (): Promise<GetAccountInfoServiceResponse> => {
      const apiResponse = await getAccountInfoApi();

      // API 응답을 Service Layer DTO로 명시적 변환
      const serviceResponse: GetAccountInfoServiceResponse = {
        businessCategory: apiResponse.data.businessCategory,
        bankName: apiResponse.data.bankName,
        bankAccountNumber: apiResponse.data.bankAccountNumber,
        bankOwnerName: apiResponse.data.bankOwnerName,
        residentRegistrationNumber: apiResponse.data.residentRegistrationNumber,
        registeredBusinessName: apiResponse.data.registeredBusinessName,
        companyRegistrationNumber: apiResponse.data.companyRegistrationNumber,
      };

      return serviceResponse;
    },

    validateServiceResponse(GetAccountInfoServiceResponseSchema),
  ),
);
